<template>
  <div>
    <div class="Blocks">
      <div class="Block_Top">
        <div class="Block_Topall">
          <span>Non - Fungble Tokens (NFT) </span>
          <span class="total notranslate"
            >A total of {{ nftList.length }} Token Contracts found</span
          >
        </div>
        <!-- <span class="total notranslate"
          >A total of 632,420 Token Contracts found</span
        > -->
        <div class="search">
          <input
            type="text"
            id="inputvalue"
            v-model.trim="value"
            @keyup.enter="search"
            placeholder="Search Contract Name or Contract address"
          />
          <img src="../../../assets/pc/Index/seach.png" @click="search" />
        </div>
      </div>
      <div v-show="nftList.length > 0">
        <div class="Block_list">
          <ul class="block_list_Top">
            <li>#</li>
            <li>Collection</li>
            <li>Items</li>
            <li>
              Holders
              <!-- <img :src="PaixuImg" /> -->
            </li>
            <li>
              Transfers
              <!-- <img :src="PaixuImg1" /> -->
            </li>
            <!-- <li>Txn</li>
            <li>Gas</li> -->
          </ul>
        </div>
        <div class="Block_List_center notranslate">
          <ul>
            <li v-for="(item, index) in nftList" :key="index">
              <p>{{ index + 20 * (PaginationIndex - 1) + 1 }}</p>
              <p @click="Block(item.contractAddress)">
                <img :src="item.logo" />
                <span>{{ item.contractName }}</span>
              </p>
              <p>
                <span v-if="item.itemCount > 999">
                  {{
                    new Intl.NumberFormat("en-US", {
                      minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                      maximumFractionDigits: 10,
                    }).format(item.itemCount)
                  }}</span
                >
                <span v-else>{{ item.itemCount }}</span>
              </p>
              <p>
                <span v-if="item.holders > 999">
                  {{
                    new Intl.NumberFormat("en-US", {
                      minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                      maximumFractionDigits: 10,
                    }).format(item.holders)
                  }}</span
                >
                <span v-else>
                  {{
                    new Intl.NumberFormat("en-US", {
                      minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                      maximumFractionDigits: 10,
                    }).format(item.holders)
                  }}</span
                >
              </p>
              <p>
                <span v-if="item.transactions > 999">
                  {{
                    new Intl.NumberFormat("en-US", {
                      minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                      maximumFractionDigits: 10,
                    }).format(item.transactions)
                  }}
                </span>
                <span v-else>
                  {{
                    new Intl.NumberFormat("en-US", {
                      minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                      maximumFractionDigits: 10,
                    }).format(item.transactions)
                  }}</span
                >
              </p>
            </li>
          </ul>
        </div>
        <div
          :class="
            nftList.length > 10 ? 'Block_List_Bottom' : 'Block_List_Bottoma'
          "
        >
          <el-pagination
            ref="Pagination"
            :current-page.sync="PaginationIndex"
            background
            layout="prev, pager,
      next"
            @current-change="CurrentChange"
            :page-size="20"
            :total="total1"
          >
          </el-pagination>
        </div>
      </div>
      <div v-show="nftList.length <= 0">
        <EmptyState />
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "../BlockList/Pagination";
import Pagination2 from "../BlockList/Pagination2.vue";
import EmptyState from "../EmptyState/EmptyState.vue";
import { BlockList } from "@/assets/server/api";
import { timestampConvertTime } from "@/utils/utils";
import { goPAGE, formatSeconds, listType, getSubStr } from "@/utils/utils";
export default {
  props: ["nftList", "totalNFTs"],
  data() {
    return {
      list: [],
      PaginationIndex: 1,
      total1: null,
      nowLang: "",
      TimeDate: [],
      Page1: "",
      value: "",
      ImgUrl: require("@/assets/pc/TopValidators/TopValidators1.png"),
      ImgUrl2: require("@/assets/pc/TopValidators/TopValidators2.png"),
      ImgUrl3: require("@/assets/pc/TopValidators/TopValidators3.png"),
      logo: "",
    };
  },
  components: {
    Pagination,
    EmptyState,
    Pagination2,
  },
  mounted() {
    this.PaginationIndex = 1;
    // this.blockList();
  },
  watch: {
    deep: true,
    totalNFTs(val) {
      // console.log(val);
      this.total1 = val;
    },
  },
  computed: {
    getClientTimezone() {
      var oDate = new Date();
      var nTimezone = -oDate.getTimezoneOffset() / 60;
      return nTimezone.toFixed(2);
    },
  },
  created() {
    this.PaixuImg = this.ImgUrl;
    this.PaixuImg1 = this.ImgUrl;
    this.PaixuImg2 = this.ImgUrl;
  },
  methods: {
    search() {
      var inputvalue = document.getElementById("inputvalue");
      if (inputvalue.innerHTML == " ") {
        return;
      }
      if (this.value == "") {
        this.$emit("search", this.value);
      } else if (this.value != "") {
        this.$emit("search", this.value);
        this.value = "";
      }
    },
    CurrentChange(val) {
      this.PaginationIndex = val;
      this.$emit("getDatepage", val);

      // this.blockList();
    },
    async blockList() {
      this.Page1 = this.getContextData("tiaozhuan1") || 1;
      const params = {
        pageNum: this.PaginationIndex,
        pageSize: 10,
      };
      const formData = new FormData();
      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      await BlockList(formData).then((res) => {
        this.list = res.result.tradeList;
        this.total1 = res.result.total;
        this.index = 1;
        var calctime = new Date();
        let strdate = Math.floor(calctime.getTime() / 1000);
        for (let i = 0; i < this.list.length; i++) {
          let UTCTime =
            res.result.tradeList[i].tradeTime -
            this.getClientTimezone * 3600000;
          this.TimeDate[i] = timestampConvertTime(UTCTime);
          let timestamp = Math.floor(
            this.gltime(this.list[i].tradeTime) / 1000
          );

          var s = strdate - timestamp;
          if (s <= 0) {
            s = 1;
          }
          this.list[i].tradeTime = formatSeconds(s);
        }
      });
    },
    Block(index) {
      let params = {
        contractAddress: index,
      };
      this.$router.push({
        path: "/pc/NFTsdetail",
        query: params,
      });
    },
    Hash(index) {
      this.$router.push({ path: "/pc/BkDetail", query: { blockHash: index } });
    },
    gltime(i) {
      const toDate = new Date(i);
      var d = toDate;
      var localTime = d.getTime();
      var localOffset = d.getTimezoneOffset() * 60000;
      var utc = localTime + localOffset;
      var offset = this.getClientTimezone;
      var korean = utc + 3600000 * offset;
      var nd = korean;
      return nd;
    },
  },
};
</script>

<style lang="less" scoped>
.Blocks {
  padding: 36px 20px;
  background: #0b0c0f;
  width: 1160px;
  border-radius: 16px 16px 16px 16px;
  .Block_Top {
    margin-bottom: 24px;
    display: flex;
    justify-content: space-between;
    .Block_Topall {
      display: flex;
      // span{
      //   width: 260px;
      //   border: 1px solid red;
      //   display: block;
      // }
      span:nth-child(2) {
        margin-top: 4px;
      }
    }
    .total {
      display: inline-block;
      font-size: 14px;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #898b8d;
      margin-left: 30px;
      line-height: 24px !important;
    }
    .search {
      width: 380px;
      height: 40px;
      background: #18191e;
      border-radius: 6px 6px 6px 6px;
      opacity: 1;
      // margin-left: 356px;
      display: flex;
      justify-content: space-between;
      /deep/ input {
        width: 310px;
        background: #18191e !important;
        height: 40px;
        border: none;
        margin-left: 20px;
        color: #fff;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        font-size: 12px;
      }
      img {
        width: 21px;
        height: 21px;
        margin-top: 12px;
        margin-right: 20px;
      }
    }
    span:nth-child(1) {
      font-size: 18px;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #ffffff;
      line-height: 24px;
      -webkit-background-clip: text;
      margin-left: 20px;
    }
  }
  .Block_list {
    .block_list_Top {
      display: flex;
      width: 1120px;
      height: 60px;
      background: #14151a;
      border-radius: 10px 10px 10px 10px;
      opacity: 1;
      padding: 0 20px;
      li {
        font-size: 16px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #898b8d;
        line-height: 62px;
        -webkit-background-clip: text;
      }
      li:nth-child(1) {
        flex: 0 0 15%;
      }
      li:nth-child(2) {
        flex: 0 0 25%;
      }
      li:nth-child(3) {
        flex: 0 0 25%;
      }
      li:nth-child(4) {
        flex: 0 0 25%;
        img {
          width: 25px;
          height: 22px;
          margin-top: 20px;
        }
      }
      li:nth-child(5) {
        flex: 0 0 10%;
        img {
          width: 25px;
          height: 22px;
          margin-top: 20px;
        }
      }
    }
  }
  .Block_List_center {
    ul {
      height: 620px;
      padding: 0 20px;
      li:last-child {
        border-bottom: none;
      }
      li {
        display: flex;
        height: 62px;
        border-bottom: 1px solid #22252e;
        line-height: 62px;
        p {
          font-size: 14px;
          font-family: SF Pro Text-Regular, SF Pro Text;
          font-weight: 400;
          -webkit-background-clip: text;
        }
      }
      li:nth-child(10) {
        // border: none;
      }
      p:nth-child(1) {
        flex: 0 0 15%;
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #898b8d;
      }
      p:nth-child(2):hover {
        color: #00e79a;
      }
      p:nth-child(2) {
        flex: 0 0 25%;
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #fff;
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        display: flex;
        // border: 1px solid red;
        img {
          width: 34px;
          height: 34px;
          background: #22252e;
          border-radius: 172px 172px 172px 172px;
          opacity: 1;
          margin-top: 16px;
          margin-right: 5px;
        }
        span {
          display: inline-block;
          // width: 280px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;
          margin-left: 8px;
        }
      }
      p:nth-child(3) {
        flex: 0 0 25%;
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #898b8d;
        position: relative;
        cursor: default;
        .Hover1 {
          display: none;
          .Hover {
            padding: 3px 10px;
            display: inline-block;
            line-height: 20px;
            position: absolute;
            top: -10px;
            left: 0px;
            background-color: #3c485c;
            border-radius: 5px;
            i {
              position: absolute;
              top: 18px;
              left: 40%;
              transform: rotate(180deg);
              color: #3c485c;
            }
          }
        }
      }
      p:nth-child(2):hover {
        .Hover1 {
          display: block !important;
        }
      }
      p:nth-child(4) {
        flex: 0 0 25%;
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #898b8d;

        span {
          display: inline-block;
          width: 280px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;
        }
      }
      p:nth-child(5) {
        flex: 0 0 10%;
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #898b8d;
      }
    }
  }
  .Block_List_Bottom {
    margin-top: 660px;
  }
  .Block_List_Bottoma {
    margin-top: 20px;
  }
}

.el-pagination {
  display: flex;
  justify-content: right;
  ::v-deep button {
    min-width: 24px !important;
    height: 24px !important;
    font-size: 12px;
    color: #fff !important;
    background: none !important;
    // background: #3c485c !important;
    border-radius: 4px 4px 4px 4px !important;
  }
  ::v-deep ul {
    li {
      min-width: 24px !important;
      height: 24px !important;
      background: none !important;
      //border-radius: 4px 4px 4px 4px !important;
      font-size: 12px;
      font-family: aaa;
      font-weight: 400 !important;
      color: #ffffff !important;
      line-height: 20px !important;
      margin: 0 4px !important;
      padding: 2px 8px !important;
    }
    .active {
      background: #22252e !important;
    }
    .more::before {
      line-height: 20px !important;
    }
  }
}
</style>
